// =============================================
// COMPONENTE: HTTPRequestNode - Nó de Requisição HTTP
// =============================================
// Arquivo: HTTPRequestNode.tsx
// Descrição: Nó avançado para fazer chamadas HTTP/REST com headers customizados
// =============================================

import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Globe, Zap, ArrowRight } from 'lucide-react';
import ActionsBadge from './ActionsBadge';
import '../NodeStyles.css';

const HTTPRequestNode: React.FC<NodeProps> = ({ data, selected }) => {
  const {
    label,
    url,
    method = 'GET',
    headers = {},
    responseVariable,
    description,
    actions
  } = data;

  const getMethodColor = (method: string) => {
    switch (method) {
      case 'GET': return '#10b981';
      case 'POST': return '#3b82f6';
      case 'PUT': return '#f59e0b';
      case 'DELETE': return '#ef4444';
      case 'PATCH': return '#8b5cf6';
      default: return '#6b7280';
    }
  };

  return (
    <div className={`flow-node http-request-node ${selected ? 'selected' : ''}`}>
      <Handle
        type="target"
        position={Position.Top}
        className="flow-handle"
      />

      <div className="node-header http-request-header">
        <Globe className="node-icon" size={18} />
        <span className="node-title">{label || 'HTTP Request'}</span>
      </div>

      <div className="node-body">
        {url && (
          <div className="node-detail">
            <Zap size={14} />
            <span
              className="node-detail-text"
              style={{ color: getMethodColor(method) }}
            >
              <strong>{method}</strong> {url.substring(0, 40)}{url.length > 40 ? '...' : ''}
            </span>
          </div>
        )}
        {responseVariable && (
          <div className="node-detail">
            <ArrowRight size={14} />
            <span className="node-detail-text">→ {responseVariable}</span>
          </div>
        )}
        {description && (
          <div className="node-description">{description}</div>
        )}
        {Object.keys(headers).length > 0 && (
          <div className="node-badge">
            {Object.keys(headers).length} header(s)
          </div>
        )}
        <ActionsBadge actions={actions} />
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        className="flow-handle"
      />
    </div>
  );
};

export default HTTPRequestNode;
